import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import TimeAgo from 'react-timeago'
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import { Typography } from '@material-ui/core';

// core components
import CardMedia from '@material-ui/core/CardMedia';
import Hidden from '@material-ui/core/Hidden';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

// import AutoStoriesIcon from '@material-ui/icons/AutoStories';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';

import ProfileLinks from './ProfileLinks';

// styles
import imagesStyles from "assets/jss/material-kit-pro-react/imagesStyles.jsx";
import cardStyles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx";

// other assets
import { cardTitle } from "assets/jss/material-kit-pro-react.jsx";

// actions
import axios from 'axios';
import { SEARCH_BASE_URL } from '../../../config';

import { MONTHS } from '../../../constants';

const styles = () => ({
    ...cardStyles,
    ...imagesStyles,
    hidden: {display: "none !important"},
    articleCardMediaGridItem: {paddingRight: 0},
    articleCardMedia: {
        height: 0,
        paddingTop: '100%', // 16:9,
        marginTop: '.625rem'

    },
    cardTitle: {
        ...cardTitle,
        color: "#000000 !important"
    },
    articleTitle: {
        lineHeight: '1.2em',
        maxHeight: '3.6em',
        overflow: 'hidden'
    },
    icon: {
        marginRight: '5px'
    },
    titleNoImage: {minWidth: "100%"},
    moreReading: {
        border: "1px solid #dadce0",
        borderRadius: "5px",
        width: "auto",
        fontWeight: "bold"
    },
    torchImg: {
        maxWidth: "50px",
        width: "auto"
    },
    newsContent: {
        overflow: 'hidden',
        position: 'relative',
        lineHeight: '1.2em',
        // maxHeight: '3.6em',
        maxHeight: '5.9em',
        fontFamily: '"Roboto Slab", "Times New Roman", serif',
        marginRight: '-1em',
        paddingRight: '1em',
        color: '#000000 !important'
    },
    fdoOrgs: {
        margin: '0 auto'
    },
    misInfoReportButton: {
        borderRadius: 0,
        // borderColor: "red",
        backgroundColor: "#febe10 !important",
        color: "#000000 !important",

        "&:hover": {backgroundColor: "red !important"}
    },
    wasReported: {
        borderRadius: 0,
        backgroundColor: "red",

        "&:hover": {backgroundColor: "green !important"}
    }
})

class ArticleBody extends Component {
    constructor(props) {
        super(props);

        const { feedback } = this.props.record;
        this.state = { reported: feedback && feedback.misInformation === "Yes" };

        this.reportArticle = this.reportArticle.bind(this);
    }

    reportArticle(e) {
        const { record } = this.props;
        this.setState({ reported: !this.state.reported }, () => {
            const payload = {
                dataId: record.data_id,
                route: "send_feedback",
                misInformation: this.state.reported ? '1' : '0',
                url: record.link,
                title: record.title,
                image: record.image
            }
            axios.post(SEARCH_BASE_URL, payload, {withCredentials: true});
        })
    }

    render() {
        const { classes, record, recordState, utcStart } = this.props;
        const hasImage = record.image && record.image !== "",
            imgUrl = !hasImage ? "assets/img/fc_logo_orange.png" : record.image,
            // pubDate = new Date(record.event_date),
            dateMatch = record.event_date.match(/(\d{4})-(\d{2})-(\d{2}).*/).slice(-3),
            // pubDateString = `${MONTHS[pubDate.getMonth()]} ${pubDate.getDate()}, ${pubDate.getFullYear()}`;
            pubDateString = `${MONTHS[parseInt(dateMatch[1]) - 1]} ${dateMatch[2]}, ${dateMatch[0]}`;

        return (
            <GridContainer>

                {/* Article image */}
                <GridItem xs={12} sm={3} md={4} className={`${classes.articleCardMediaGridItem} ${!hasImage ? classes.hidden : ''}`}>
                    <Hidden xsDown>
                        <CardMedia 
                            className={classes.articleCardMedia}
                            image={imgUrl}
                            title="Image title"
                        />
                    </Hidden>
                </GridItem>

                {/* Article title */}
                <GridItem xs={12} sm={9} md={8} className={!hasImage ? classes.titleNoImage : ""}>
                    <a href={record.link} target="_blank" rel="noopener noreferrer">
                        <div className="title-clamp">
                            <h4 className={`${classes.cardTitle} ${classes.articleTitle}`} dangerouslySetInnerHTML={{ __html: record.title }}></h4>
                        </div>
                    </a>

                    {/* Added date, author and Torch information */}
                    <Typography variant="caption" gutterBottom noWrap color="textSecondary">
                        { record.author ? <div> Author - {record.author}</div> : null }
                        { record.event_date ? <div>{ pubDateString }</div> : null }
                        { <div>Added <TimeAgo date={record.insert_date ? record.insert_date : record.event_date} now={() => utcStart}/> </div> }
                        { record.data_id ? <div> ID: { record.data_id }</div> : null }
                        { record.is_opinion ? <div> <b>Opinion</b> </div> : null }
                        {
                            record.data_source === "torch" ? 
                                <div>powered by <a href="https://www.torch1.com/">
                                    <img className={classes.torchImg} src="https://www.torch1.com/landing/img/logo-torch@2x.png" /></a>
                                </div>
                                : null
                        }

                        {/* <Button 
                            size="sm"
                            color="primary"
                            className={this.state.reported ? classes.wasReported : classes.misInfoReportButton}
                            value="mis_info_report"
                            onClick={this.reportArticle}>
                            Report mis-information
                        </Button> */}
                    </Typography>

                    {/* Have the review items for this article been completed? */}
                    {
                        record.complete || (recordState && recordState.complete) ?
                            <i className="fas fa-check-square complete"> review complete</i>
                            : null
                    }
                </GridItem>

                {/* Are there any articles related to this one? */}
                {
                    record.similar_ids && record.similar_ids.length > 0 ?
                        <GridItem xs={12} sm={9} md={8} className={ classes.moreReading }>
                            <LibraryBooksIcon iconcolor="info" className={classes.icon}/>
                            <Link to={`/related/${record.data_id}`} target="_blank">
                                Related Content
                            </Link>
                        </GridItem>
                        : null
                }

                {/* Article text snippet */}
                <p className={classes.newsContent} dangerouslySetInnerHTML={{ __html: record.content }}></p>

                <GridItem xs={12} sm={9} md={8}>
                    <Button 
                        size="sm"
                        color="primary"
                        className={this.state.reported ? classes.wasReported : classes.misInfoReportButton}
                        value="mis_info_report"
                        onClick={this.reportArticle}>
                        Report mis-information
                    </Button>
                </GridItem>
                
                {/* Links to orgamization profiles in FDO */}
                <GridItem xs={12} sm={9} md={8} className={classes.fdoOrgs}>
                    <ProfileLinks 
                        organizations={ record.org_profiles } 
                        numOrganizations={2}
                        subjects={ record.subject_data }
                        numSubjects={2}
                    />
                </GridItem>
                        
            </GridContainer>
        )
    }
}

ArticleBody.propTypes = {
    classes: PropTypes.object,
    record: PropTypes.object,
    recordState: PropTypes.object,
    utcStart: PropTypes.instanceOf(Date)
}

export default withStyles(styles)(ArticleBody);


// WEBPACK FOOTER //
// ./src/components/Article/common/ArticleBody.jsx